<template>
  <div class="w-full h-full flex flex-col mt-1">
    <div class="w-full h-full">
      <div v-show="!isEditing" class="flex items-center h-full">
        <v-menu>
          <template v-slot:activator="{ props }">
            <button
              v-bind="props"
              class="bg-[#D6EEF5] text-black text-sm font-light px-4 py-3 rounded-md w-full h-full min-h-[48px] flex items-center justify-between"
            >
              <span class="text-center flex-1">{{ position }}</span>
              <ArrowIcon class="w-4 h-4 shrink-0" />
            </button>
          </template>
          <v-list density="compact">
            <v-list-item
              v-for="(item, index) in ['Renomear', 'Desativar']"
              :key="index"
              :value="item"
              @click="handleMenuAction(index)"
            >
              <template #append>
                <EditIcon v-if="index === 0" />
                <DeleteIcon v-else />
              </template>
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div v-show="isEditing" class="flex items-center">
        <v-text-field
          v-model="position"
          label="Nome da Posição*"
          variant="outlined"
          color="primary20"
          hide-details
          density="compact"
        >
          <template #append-inner>
            <EditIcon class="cursor-pointer" @click="editPosition" />
          </template>
        </v-text-field>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import ArrowIcon from '@/assets/icons/down.vue'
import EditIcon from '@/assets/icons/edit.vue'
import DeleteIcon from '@/assets/icons/delete.vue'

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'edit'): void
  (e: 'rename', value: string): void
  (e: 'deactivate'): void
}>()

const isEditing = ref(false)
const position = ref(props.modelValue)

watch(
  () => props.modelValue,
  (val) => {
    position.value = val
  }
)

const editPosition = () => {
  emit('edit')
  emit('update:modelValue', position.value)
  isEditing.value = false
}

const handleMenuAction = (index: number) => {
  if (index === 0) {
    isEditing.value = true
    emit('rename', position.value)
  } else {
    emit('deactivate')
  }
}
</script>
